module["exports"] = [
  "España"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es/address/default_country.js
// module id = 839
// module chunks = 0